(function() { module.exports = window["VueRouter"]; }());